// extracted by mini-css-extract-plugin
export default {"general":"general--TuVXZ"};